import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const updateProject = {
    namespaced: true,
    state: {
        isFetchingUpdate: false,
        typeInfoProjectUpdate: "",
        headInfoProjectUpdate: "",
        isProjectUpdate: false,
        textInfoProjectUpdate: ""
    },
    mutations: {
        SUCCESS_UPDATE_PROJECT(state, response) {
            state.typeInfoProjectUpdate = "green";
            state.headInfoProjectUpdate = response.data.message;
            state.textInfoProjectUpdate = response.data.data.textInfo;
            state.isProjectUpdate = true;
            eventBus.$emit("updateProjectSuccess");
        },
        FAILURE_UPDATE_PROJECT(state, error) {
            state.textInfoProjectUpdate = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoProjectUpdate = "red";
            state.headInfoProjectUpdate = error.response.data.message;
            state.isProjectUpdate = true;
            eventBus.$emit("saveProjectFailure", error.response.data.errors);
        },
        UPDATE_DATA_REQUEST(state, value) {
            state.isFetchingUpdate = value;
        },
        UPDATE_VISIBLE_MODAL_UPDATE(state, value) {
            state.isProjectUpdate = value;
        }
    },
    actions: {
        updateProject: function({dispatch}, payload) {
            dispatch("requestDataUpdate", true);
            let url = new URL(window.location.href);
            var promise = sendRequest("put", config.baseURLApi + "/projects/" + url.searchParams.get("id"), {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("updateProjectSuccess", result[1]);
                } else {
                    dispatch("updateProjectFailure", result[1]);
                }
                dispatch("requestDataUpdate", false);
            });
        },
        requestDataUpdate: function({commit}, value) {
            commit("UPDATE_DATA_REQUEST", value);
        },
        updateProjectSuccess: function({commit}, response) {
            commit("SUCCESS_UPDATE_PROJECT", response);
        },
        updateProjectFailure: function({commit}, error) {
            commit("FAILURE_UPDATE_PROJECT", error);
        },
        updateVisibleModalUpdate: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_UPDATE", value);
        }
    }
}

export default updateProject;